import { css } from 'emotion';

export const buttonContainer = (hideButton: boolean, isAlwaysVisible: boolean) => css`
  display: ${hideButton ? 'none' : 'flex'};
  justify-content: flex-end;

  & > button {
    opacity: ${isAlwaysVisible ? 1 : 0};
  }
`;

export const checkboxSpan = css`
  width: fit-content;
  display: flex;
`;
